import { BookingStep } from '@ibe/models/ui';
import { Action } from '@ngrx/store';
import { type } from '../util';
import { BookingType } from '@ibe.models/booked-trip.model.lib';
import { DailyCost } from '@ibe.models/daily-cost.model';


export const ActionTypes = {
	LOADING: type('[BookingSteps] loading '),
	PUT_BOOKINGSTEPS: type('[BookingSteps] Update'),
	PUT_STEPS: type('[BookingSteps] put Steps'),
	PUT_CURRENTSTEP: type('[BookingSteps] put Current Step'),
	PUT_CURRENTPAGE: type('[BookingSteps] put Current Page'),
	PUT_BOOKINGTYPE: type('[BookingSteps] put Type'),
	PUT_ALL_COSTS_PER_DAY: type('[BookingSteps] put allCostsPerDay'),
	PUT_TTT: type('[BookingSteps] put timeToThink'),
	RESET_SELECTED_FLIGHT: type('[BookingSteps] ResetSelectedFlights'),
	RESELECT_LAST_FLIGHT: type('[BookingSteps] ReselectLastFlightAction'),
	RESET: type('[BookingSteps] Reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutBookingStepsAction implements Action {
	type = ActionTypes.PUT_BOOKINGSTEPS;


	/**
	 *Creates an instance of PutBookingStepsAction.
	 * @param {*} payload
	 * @memberof PutBookingStepsAction
	 */
	constructor(public payload?) { }
}

export class PutStepsAction implements Action {
	type = ActionTypes.PUT_STEPS;


	/**
	 *Creates an instance of PutBookingStepsAction.
	 * @param {*} payload
	 * @memberof PutBookingStepsAction
	 */
	constructor(public payload: BookingStep[]) { }
}

export class PutCurrentStepAction implements Action {
	type = ActionTypes.PUT_CURRENTSTEP;


	/**
	 *Creates an instance of PutCurrentStepAction.
	 * @param {number} payload
	 * @memberof PutCurrentStepAction
	 */
	constructor(public payload: number) { }
}

export class PutCurrentPageAction implements Action {
	type = ActionTypes.PUT_CURRENTPAGE;


	/**
	 *Creates an instance of PutCurrentPageAction.
	 * @param {'dates' | 'flights'} payload
	 * @memberof PutCurrentPageAction
	 */
	constructor(public payload: 'dates' | 'flights' | 'review' | 'extras' | 'payment' | 'timeToThink') { }
}

export class PutBookingTypeAction implements Action {
	type = ActionTypes.PUT_BOOKINGTYPE;


	/**
	 *Creates an instance of PutBookingTypeAction.
	 * @param {BookingType} payload
	 * @memberof PutBookingTypeAction
	 */
	constructor(public payload: BookingType) { }
}

export class PutAllCostsPerDayAction implements Action {
	type = ActionTypes.PUT_ALL_COSTS_PER_DAY;

	/**
	 *Creates an instance of PutAllCostsPerDayAction.
	 * @param {Array<DailyCost>} payload
	 * @memberof PutAllCostsPerDayAction
	 */
	constructor(public payload: Array<DailyCost>) { }
}

export class PutTimeToThinkAction implements Action {
	type = ActionTypes.PUT_TTT;


	/**
	 *Creates an instance of PutTimeToThinkAction.
	 * @param {boolean} payload
	 * @memberof PutTimeToThinkAction
	 */
	constructor(public payload: boolean) { }
}

export class ResetSelectedFlightAction implements Action {
	type = ActionTypes.RESET_SELECTED_FLIGHT;
	/**
	 *Creates an instance of ResetSelectedFlightAction.
	 * @param {*} [payload]
	 * @memberof ResetSelectedFlightAction
	 */
	constructor(public payload?) { }
}

export class ReselectLastFlightAction implements Action {
	type = ActionTypes.RESELECT_LAST_FLIGHT;
	/**
	 *Creates an instance of ReselectLastFlightAction.
	 * @param {*} [payload]
	 * @memberof ReselectLastFlightAction
	 */
	constructor(public payload?) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;
	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions =
	LoadingAction |
	PutBookingStepsAction |
	PutStepsAction |
	PutBookingTypeAction |
	ResetAction |
	ResetSelectedFlightAction |
	ReselectLastFlightAction |
	PutCurrentStepAction |
	PutCurrentPageAction |
	PutTimeToThinkAction |
	PutAllCostsPerDayAction;
